import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUpdatePersonPayload } from 'api/actions/hr-update-person/hr-update-person-payload';
import { HrUpdatePersonPathParameters } from 'api/actions/hr-update-person/hr-update-person-path-parameters';
import { HrUpdatePersonResponse } from 'api/actions/hr-update-person/hr-update-person-response';

type HrUpdatePersonQueryParameters = Record<string, any>;

/**
 * The path of the HrUpdatePerson action.
 */
export const hrUpdatePersonActionPath = new SweetPath<keyof HrUpdatePersonPathParameters>('/api/hr/people/{personId}', {
  path: '{param}',
});

/**
 * Creates a contextualized HrUpdatePerson actions.
 */
export default function createHrUpdatePersonAction(axios: AxiosInstance) {
  return function hrUpdatePersonAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUpdatePersonPathParameters;
    query?: HrUpdatePersonQueryParameters;
    payload: HrUpdatePersonPayload;
  }) {
    const path = hrUpdatePersonActionPath.insert(parameters);

    return axios.request<HrUpdatePersonResponse, HrUpdatePersonResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
